import { z } from 'zod';
import i18n from '../i18n';

const optionalPiva = z
  .string()
  .refine((v) => !v || /^\d{11}$/.test(v), { message: i18n.t('anagrafiche.val_produttore.piva') })
  .optional();

// 16 caratteri (persona fisica) oppure 11 cifre (ente senza P.IVA). Vedi
// `schemas/cliente.ts`: stessa regola, il checksum lo verifica il backend.
const optionalCf = z
  .string()
  .refine((v) => !v || v.length === 16 || /^\d{11}$/.test(v), { message: i18n.t('anagrafiche.val_produttore.cf') })
  .optional();

const optionalEmail = z
  .string()
  .refine((v) => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v), { message: i18n.t('anagrafiche.val_produttore.email') })
  .optional();

const optionalProvincia = z
  .string()
  .refine((v) => !v || v.length === 2, { message: i18n.t('anagrafiche.val_produttore.provincia') })
  .optional();

const optionalCap = z
  .string()
  .refine((v) => !v || /^\d{5}$/.test(v), { message: i18n.t('anagrafiche.val_produttore.cap') })
  .optional();

// Blocco 6: i campi omologa_* sono stati rimossi dal produttore (drop V27).
// L'omologa è ora un'entità separata gestita via DettaglioProduttorePage > sezione Omologhe.
export const produttoreCreateSchema = z
  .object({
    ragione_sociale: z.string().min(1, i18n.t('anagrafiche.val_produttore.ragione_sociale')),
    piva: optionalPiva,
    codice_fiscale: optionalCf,
    email: optionalEmail,
    telefono: z.string().optional(),
    indirizzo: z.string().optional(),
    citta: z.string().optional(),
    provincia: optionalProvincia,
    cap: optionalCap,
    note: z.string().optional(),
    tipo_soggetto: z.string().optional(),
  })
  .refine((data) => !!(data.piva?.trim() || data.codice_fiscale?.trim()), {
    message: i18n.t('anagrafiche.val_produttore.piva_o_cf'),
    path: ['piva'],
  });

export const produttoreUpdateSchema = z.object({
  ragione_sociale: z.string().min(1, i18n.t('anagrafiche.val_produttore.ragione_sociale')).optional(),
  piva: optionalPiva,
  codice_fiscale: optionalCf,
  email: optionalEmail,
  telefono: z.string().optional(),
  indirizzo: z.string().optional(),
  citta: z.string().optional(),
  provincia: optionalProvincia,
  cap: optionalCap,
  note: z.string().optional(),
  tipo_soggetto: z.string().optional(),
});

export type ProduttoreCreateData = z.infer<typeof produttoreCreateSchema>;
export type ProduttoreUpdateData = z.infer<typeof produttoreUpdateSchema>;
